<div class="container-fluid full-height">
    @if (isAppInitialized) {
        <router-outlet></router-outlet>
    } @else {
        <sb-internal-server-error-page></sb-internal-server-error-page>
    }
</div>
<simple-notifications></simple-notifications>
